import React from "react";
import {Link} from "react-router";

import {IconButton, TextField, Tooltip} from "@material-ui/core";
import LinkIcon from "@material-ui/icons/Link";
import Autocomplete from "@material-ui/lab/Autocomplete";

import {OrganisationId} from "common/types/organisation";
import {ProjectId} from "common/types/project";
import {DocumentId} from "common/types/document";
import {Document} from "../containers/data_assets_base";

const styles = {
  autocompleteOption: {
    whiteSpace: "normal",
    wordWrap: "break-word",
    overflowWrap: "break-word",
    wordBreak: "break-all",
    maxWidth: "100%",
    textOverflow: "ellipsis",
  },
  autocompleteListbox: {
    maxWidth: 300,
    width: "100%",
    overflowX: "hidden",
  },
  container: {
    display: "flex",
    alignItems: "center",
  },
} as const;

interface Props {
  organisationId: OrganisationId;
  projectId: ProjectId | null;
  documents: Document[];
  documentId?: DocumentId | null;
  selectDocument: (documentId: DocumentId | null) => void;
  autocompleteStyle?: object;
}

export default function DocumentSelector({
  organisationId,
  projectId,
  documents,
  documentId,
  selectDocument,
  autocompleteStyle,
}: Props) {
  const documentsAvailable = Array.isArray(documents) && documents.length > 0;

  const selectedDocument =
    documentId && documentsAvailable
      ? documents.find(doc => doc.id === documentId) || null
      : null;

  const handleDocumentChange = (event, newValue: Document | null) => {
    selectDocument(newValue?.id ?? null);
  };

  return (
    <div style={styles.container}>
      <Autocomplete
        style={autocompleteStyle ?? {}}
        options={documentsAvailable ? documents : []}
        getOptionLabel={option => option.name}
        value={selectedDocument}
        onChange={handleDocumentChange}
        disabled={!documentsAvailable}
        renderInput={params => (
          <TextField
            {...params}
            label={
              !documentsAvailable ? "No documents available" : "Select Document"
            }
            variant="outlined"
          />
        )}
        renderOption={option => (
          <div style={styles.autocompleteOption} title={option.name}>
            {option.name}
          </div>
        )}
        ListboxProps={{
          style: styles.autocompleteListbox,
        }}
        disableListWrap={false}
      />
      {documentId && projectId ? (
        <Tooltip title="Go to document">
          <Link
            to={`/organisation/${organisationId}/project/${projectId}/document/${documentId}/detail`}
          >
            <IconButton>
              <LinkIcon />
            </IconButton>
          </Link>
        </Tooltip>
      ) : null}
    </div>
  );
}
